import React, { useDeferredValue, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { FilterFilled, SearchOutlined } from '@ant-design/icons';
import AdminHeaderTab from '../../../Components/headerTab/AdminHeaderTab'
import { Button, Select, Spin, Table, Typography } from 'antd'
import { useAppMessage } from '../../../hooks/useAppMessage'
import { LogsFilter } from '../../../Components/modals/LogsFilter';
import { LogsAPI } from '../../../API/admin/LogsAPI';
import TableEmptyContent from '../../../Components/TableEmptyContent/TableEmptyContent';
import { EMPLOYEE_COLUMNS_HEAD } from './LogsUtils';
const { Text } = Typography;

function Logs() {
    const [messageApi, contextHolder] = useAppMessage();
    const [spinning, setSpinning] = useState(false)
    const [serachVal, setSearchVal] = useState('');
    const [openFilter, setOpenFilter] = useState(false);
    const [logData, setLogData] = useState([]);
    const [logTypeList, setLogTypeList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [defualtData, setDefualtData] = useState([])
    const [filterElements, setFilterElements] = useState({
        logType: '',
        user: '',
        startDate: '',
        endDate: ''
    })

    // useDefferedValue
    const deferredQuery = useDeferredValue(serachVal);
    useEffect(() => {
        serachFun()
    }, [deferredQuery]);

    async function loadLogData() {
        setSpinning(true)
        await LogsAPI.getLogList()
            .then(res => {
                if (res.data.status === true) {
                    let arr = []
                    res.data?.log_type_list.filter(ele => {
                        if (ele !== null) {
                            arr.push({ value: ele, label: ele })
                        }
                    })

                    let array = res.data?.data
                    array.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });
                    const logarr = array.map((ele, index) => ({ ...ele, serial_no: index + 1 }));

                    setLogData(logarr);
                    setDefualtData(logarr)
                    setLogTypeList(arr);
                    setUserList(res.data?.user_list);
                    setFilterElements(prev => ({ ...prev, logType: res.data?.log_type }));
                } else {
                    messageToast('error', res.data?.message);
                }
            })
            .catch(() => messageToast('error', "Internal Server Error"))
            .finally(() => setSpinning(false))
    }

    async function filterDataFun(data, close = false) {
        setSpinning(true)
        setFilterElements(prev => ({
            ...prev,
            logType: data.log_type,
            user: data.user,
            startDate: data.start_date,
            endDate: data.end_date
        }))
        await LogsAPI.getLogFilterList(data)
            .then(res => {
                if (res.data.status === true) {
                    let array = res.data?.data
                    array.sort(function (a, b) {
                        return new Date(b.created_at) - new Date(a.created_at);
                    });
                    const logarr = array.map((ele, index) => ({ ...ele, serial_no: index + 1 }));

                    setLogData(logarr);
                    setDefualtData(logarr)
                    setSearchVal("")

                    if (close === true) {
                        setOpenFilter(false);
                    }
                } else {
                    messageToast('error', res.data?.message);
                }
            })
            .catch(() => messageToast('error', "Internal Server Error"))
            .finally(() => setSpinning(false))
    }

    useEffect(() => {
        loadLogData();
    }, []);

    const messageToast = (type, message) => {
        messageApi.open({
            type: type,
            content: message,
            duration: 6,
        });
    };

    function serachFun() {
        let arr = [...defualtData];
        const filterArr = arr.filter((ele) => {
            return (
                (!serachVal.trim() || ele.log.toLowerCase().includes(serachVal.trim().toLowerCase()))
            )
        })
        setLogData(filterArr)
    }

    return (
        <div className='container_div'>
            <Helmet>
                <title>SpecOptimizer | Admin</title>
            </Helmet>

            <AdminHeaderTab currrentTab='Logs' />

            <Spin spinning={spinning}>
                <div className='admin_tab_content_wraper'>
                    <div className='table_head_wraper'>
                        <Text className='table_head' >{!filterElements.startDate && !filterElements.endDate ? 'Current Logs' : `Logs of ${String(filterElements.startDate).slice(0, 10)} to ${String(filterElements.endDate).slice(0, 10)}`}</Text>
                        <div className='table_custom_buttons'>
                            <Select
                                className='cutom_select'
                                style={{
                                    fontSize: '13px',
                                    width: 200,
                                    flex: '1 1 0px',
                                    marginRight: '10px',
                                    textAlign: 'center'
                                }}
                                placeholder='--slect log Type--'
                                value={filterElements.logType}
                                onChange={(e) => {
                                    setFilterElements(prev => ({ ...prev, logType: e }))
                                    const bodyData = {
                                        "log_type": e,
                                        "user": filterElements.user,
                                        "start_date": filterElements.startDate,
                                        "end_date": filterElements.endDate
                                    }
                                    filterDataFun(bodyData)
                                }}
                                options={logTypeList}
                            />
                            <div
                                style={{
                                    borderRadius: '25px',
                                    backgroundColor: '#EBEEF8',
                                    color: '#737373',
                                    display: 'flex',
                                    marginRight: '10px',
                                    flex: '1 1 0px'
                                }}
                            >
                                <input value={serachVal} onChange={(e) => setSearchVal(e.target.value)} className='searc_input' />
                                <SearchOutlined className='search_btn' style={{ color: !serachVal ? '#737373' : '#ff4d4f', fontSize: '18px', padding: '10px', borderRadius: '6px', }} />
                            </div>
                            <Button type='primary' onClick={() => setOpenFilter(true)} icon={<FilterFilled />}>Filter</Button>
                        </div>
                    </div>

                    <Table
                        rowKey="id"
                        columns={EMPLOYEE_COLUMNS_HEAD()}
                        dataSource={logData}
                        pagination={{
                            pageSize: 10,
                            responsive: true,
                            hideOnSinglePage: true
                        }}
                        className='antdTable'
                        locale={{
                            emptyText: <TableEmptyContent />,
                        }}
                    />
                </div>
            </Spin>
            {contextHolder}

            <LogsFilter open={openFilter} setOpen={setOpenFilter} userList={userList} filterDataFun={filterDataFun} filterElements={filterElements} setFilterElements={setFilterElements} />
        </div>
    )
}

export default Logs